import { render, staticRenderFns } from "./AvanzadaSignSegpres.vue?vue&type=template&id=13059d20&scoped=true&"
import script from "./AvanzadaSignSegpres.vue?vue&type=script&lang=js&"
export * from "./AvanzadaSignSegpres.vue?vue&type=script&lang=js&"
import style0 from "./AvanzadaSignSegpres.vue?vue&type=style&index=0&id=13059d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13059d20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13059d20')) {
      api.createRecord('13059d20', component.options)
    } else {
      api.reload('13059d20', component.options)
    }
    module.hot.accept("./AvanzadaSignSegpres.vue?vue&type=template&id=13059d20&scoped=true&", function () {
      api.rerender('13059d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/advanced/segpres/AvanzadaSignSegpres.vue"
export default component.exports